import { render, staticRenderFns } from "./LanguageSelectCom.vue?vue&type=template&id=91d9e7a6&scoped=true"
import script from "./LanguageSelectCom.vue?vue&type=script&lang=js"
export * from "./LanguageSelectCom.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelectCom.vue?vue&type=style&index=0&id=91d9e7a6&prod&lang=scss&scoped=true"
import style1 from "./LanguageSelectCom.vue?vue&type=style&index=1&id=91d9e7a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d9e7a6",
  null
  
)

export default component.exports